import Swal, { SweetAlertCustomClass } from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const formikAlert = (form: any, preConfirm: any, customClass?: SweetAlertCustomClass, title?: string, confirmButtonText?: string) =>
    withReactContent(Swal).fire({
        title: title || 'Edit Club Profile',
        confirmButtonText: confirmButtonText || 'Save',
        html: form,
        didOpen: () => {
            Swal.getPopup()?.querySelector('input')?.focus();
        },
        showCancelButton: true,
        preConfirm: preConfirm,
        customClass: customClass
    });
